import {
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    Button,
    Divider,
} from "@mui/material";
import { useState } from "react";
import DataGridDeactivateStrategy from "src/components/data-grid/activations/data-grid-deactivate-strategy";
import { useDisableActivationsMutation } from "src/context/api/activations/api";

export default function ModalDeactivateStrategy({
    open,
    row,
    onClose,
    setLocalPatches,
    refetch
}: {
    open: boolean;
    row: any;
    onClose: () => void;
    setLocalPatches: any;
    refetch: any;
}) {
    const [disableActivations] = useDisableActivationsMutation();
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        if (!row) return;

        const idsToDeactivate = row.flatMap((r: any) =>
            r.activations_details
                ?.filter((d: any) => d.status === true)
                .map((d: any) => d.id) ?? []
        );

        if (idsToDeactivate.length === 0) return onClose();

        try {
            setLoading(true);
            const response = await disableActivations({ ids: idsToDeactivate }).unwrap();

            setLocalPatches((prev: any) => {
                const updated = { ...prev };

                row.forEach((r: any) => {
                    const nextActivations =
                        r.activations_details?.filter(
                            (d: any) => !idsToDeactivate.includes(d.id)
                        ) ?? [];

                    const koManual = nextActivations.find(
                        (a: any) =>
                            a.status &&
                            a.mode === "KO Bidding Manual"
                    );

                    updated[r.id] = {
                        ...r,
                        activations_details: nextActivations,
                        max_cpc: koManual?.max_cpc ?? null,
                        mode: nextActivations?.[0]?.mode ?? null,
                    };
                });

                return updated;
            });

            refetch()
            onClose();
        } catch (err) {
            console.error("Erreur lors de la désactivation :", err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog
            open={open && !!row}
            onClose={onClose}
            maxWidth="xl"
            fullWidth
            PaperProps={{
                sx: {
                    backgroundColor: "white",
                    borderRadius: 3,
                    py: 3,
                    color: "#FFF",
                    zIndex: 99999,
                },
            }}
        >
            <DialogTitle>
                <Typography color={'rgba(51, 60, 71, 1)'} fontWeight={600} fontSize={17}>
                    Deactivate strategy
                </Typography>
            </DialogTitle>

            <DialogContent>
                <Divider sx={{ borderColor: "rgba(145, 158, 171, 0.20))" }} />

                <Box mt={"16px"}>
                    {open && row && (
                        <DataGridDeactivateStrategy
                            rows={row}
                            onChange={(newRow) => console.log(newRow)}
                        />
                    )}
                </Box>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button
                    sx={{
                        backgroundColor: "rgba(145, 158, 171, 0.12)",
                        color: "rgba(145, 158, 171, 1)",
                        "&:hover": { backgroundColor: "rgba(145, 158, 171, 0.24)" },
                    }}
                    onClick={onClose}
                    variant="contained"
                    color="inherit"
                    disabled={loading}
                >
                    Cancel
                </Button>

                <Button
                    sx={{
                        backgroundColor: "rgba(24, 24, 24, 1)",
                        "&:hover": { backgroundColor: "rgba(24, 24, 24, .9)" },
                        color: 'white'
                    }}
                    onClick={handleSubmit}
                    variant="contained"
                    disabled={loading}
                >
                    {loading ? "Deactivating..." : "Deactivate"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
